var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { animateScroll } from 'react-scroll';
import { useTheme } from 'styled-components';
import { classNames } from '../../utils/styles';
import { SectionTitle } from '../styles';
import { LeftIcon } from './icons/Left';
import { RightIcon } from './icons/Right';
import { Cards, CardImage, CatalogSectionContainer, CircleNavigationButton, } from './styles';
import { useHorizontalScroll } from './useHorizontalScroll';
var navigationScrollIncrement = 300;
export var Catalog = function (_a) {
    var section = _a.section;
    var theme = useTheme();
    var pageTitle = section.pageTitle, items = section.items, id = section.id;
    var showTitle = !!pageTitle;
    var showNavigationButtons = items.length > 2;
    var _b = useHorizontalScroll(), scrollRef = _b.scrollRef, navigationControl = _b.navigationControl;
    var navigationRightHandler = function (position) {
        var _a;
        animateScroll.scrollTo(position, {
            containerId: (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.id,
            horizontal: true,
            smoth: true,
            duration: 500,
        });
    };
    return items.length ? (_jsxs(CatalogSectionContainer, { children: [showTitle && (_jsx(SectionTitle, __assign({ className: "title" }, { children: pageTitle }), void 0)), _jsx(Cards, __assign({ ref: scrollRef, id: "cards-" + id }, { children: items.map(function (item) { return (_jsxs("div", __assign({ onClick: function () { return window.open(item.link); }, className: classNames('card', {
                        'full-width': items.length === 1,
                        bpt: !showTitle,
                    }) }, { children: [_jsx(CardImage, { "$image": item.image }, void 0), _jsxs("div", __assign({ className: "info" }, { children: [_jsxs("div", { children: [_jsx("h5", __assign({ className: "semibold" }, { children: item.title }), void 0), _jsx("p", { children: item.description }, void 0)] }, void 0), _jsx("div", { children: _jsx("h6", { children: item.linkTitle }, void 0) }, void 0)] }), void 0)] }), item.id)); }) }), void 0), showNavigationButtons && (_jsxs("div", __assign({ className: "navigation-section" }, { children: [_jsx(CircleNavigationButton, __assign({ className: classNames({
                            disabled: navigationControl.previousDisabled,
                        }), onClick: function () {
                            var _a;
                            return navigationRightHandler((((_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0) -
                                navigationScrollIncrement);
                        } }, { children: _jsx(LeftIcon, { color: theme.secondary }, void 0) }), void 0), _jsx(CircleNavigationButton, __assign({ className: classNames({
                            disabled: navigationControl.nextDisabled,
                        }), onClick: function () {
                            var _a;
                            return navigationRightHandler((((_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0) +
                                navigationScrollIncrement);
                        } }, { children: _jsx(RightIcon, { color: theme.secondary }, void 0) }), void 0)] }), void 0))] }, void 0)) : null;
};
